import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { AppContext } from '../../AppContext';
import { rejectOrderReview, getInspectorAssignedToOrder } from '../../services';
import { clDeliveredOrderLineStatusLookupId, qaCompletedOrderLineStatusLookupId } from '../QaOrderReview/constants';
import { OrderReviewContext } from '../QaOrderReview/OrderReviewContext';
import { accountStatuses } from '../../enums';

const styles = theme => ({});

const propTypes = {
  classes: PropTypes.object.isRequired,
};

export const ReturnOrderDialog = withRouter(
  withStyles(styles)(({ classes, history, orderLineId, open, setOpen, defaultReason = null, onClose }) => {
    const { dispatch: appDispatch } = useContext(AppContext);
    const [dialogOpen, setDialogOpen] = useState(open);
    const [reason, setReason] = useState(defaultReason);
    const [inspector, setInspector] = useState(null);
    const [inspectorLoading, setInspectorLoading] = useState(false);

    const getInspectorAssignedToOrderAsync = async () => {
      try {
        setInspectorLoading(true);
        const result = await getInspectorAssignedToOrder(orderLineId);
        setInspector(result);
      } catch (error) {
        console.log(error);
      }
      setInspectorLoading(false);
    };

    const showSnackbar = (message, variant) => {
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: { isOpen: true, message: message, variant: variant },
      });
    };

    const toggleSidebar = open => {
      appDispatch({
        type: 'SET_SIDEBAR_IS_OPEN',
        sidebarIsOpen: open,
      });
    };

    const handleDialogClose = () => {
      setDialogOpen(false);
      !!onClose && onClose();
    };

    const handleReasonOnChange = event => {
      setReason(event.target.value);
    };

    const rejectOrderReviewAsync = () => {
      setDialogOpen(false);
      rejectOrderReview(orderLineId, reason)
        .then(data => {
          if (data) {
            toggleSidebar(false);
            history.push('/orders/qa');
            showSnackbar('Order status updated successfully.', 'success');
          } else {
            showSnackbar('An error occurred. Please try again.', 'error');
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          !!onClose && onClose();
        });
    };

    useEffect(() => {
      setDialogOpen(open);
    }, [open]);

    useEffect(() => {
      if (dialogOpen) {
        getInspectorAssignedToOrderAsync();
      } else {
        setOpen(dialogOpen);
      }
    }, [dialogOpen]);

    const fieldRepInactive = inspector?.accountStatusId === accountStatuses.INACTIVE;

    return (
      <Dialog open={dialogOpen} onClose={handleDialogClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title" className="row-start-center">
          Return Order
          {inspectorLoading && <CircularProgress size={20} style={{ marginLeft: 20 }} />}
        </DialogTitle>
        <DialogContent
          style={{ opacity: inspectorLoading ? 0.7 : 1, pointerEvents: inspectorLoading ? 'none' : 'auto' }}
        >
          {fieldRepInactive && (
            <DialogContentText style={{ color: 'red' }}>
              The field rep that you are returning this order to is no longer active as an inspector. If possible,
              please fix the report and send to the client. If the required info/photos are missing and this requires a
              revisit, contact the QA Manager.
            </DialogContentText>
          )}
          <DialogContentText>
            The order will be marked as 'Returned' and sent back to the field inspector. Please explain why the order
            has been returned:
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="rejection-reason"
            label="Reason"
            type="text"
            multiline
            fullWidth
            required
            defaultValue={defaultReason}
            onChange={handleReasonOnChange}
            disabled={inspectorLoading}
          />
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={rejectOrderReviewAsync}>Submit</Button>
        </DialogActions>
      </Dialog>
    );
  }),
);

ReturnOrderDialog.propTypes = propTypes;
ReturnOrderDialog.defaultProps = {};
